import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ShieldCheck,
  Users,
  HeartHandshake,
  Scale,
  Megaphone,
  SearchCheck,
  Clock3,
  ChevronDown,
  ExternalLink,
  X,
  Eye,
  Building2,
  GraduationCap,
  UserCheck,
} from "lucide-react";


const members = [
  {
    id: 1,
    name: "মাইমুনা খাতুন",
    designation: "সহকারী অধ্যাপক",
    department: "ইংরেজি ভাষা ও সাহিত্য বিভাগ",
    role: "সভাপতি",
    type: "president",
  },
  {
    id: 2,
    name: "সাকেরা বেগম",
    designation: "সহকারী অধ্যাপক",
    department: "ব্যবসায় প্রশাসন বিভাগ",
    role: "সদস্য",
  },
  {
    id: 3,
    name: "সুমনা সুলতানা",
    designation: "প্রভাষক",
    department: "কম্পিউটার সায়েন্স এন্ড ইঞ্জিনিয়ারিং বিভাগ",
    role: "সদস্য",
  },
  {
    id: 4,
    name: "তাসফিকিয়া সাইমা চৌধুরী",
    designation: "প্রভাষক",
    department: "ইলেকট্রিক্যাল এন্ড ইলেকট্রনিক ইঞ্জিনিয়ারিং",
    role: "সদস্য",
  },
  {
    id: 5,
    name: "নকশী সাহা",
    designation: "প্রভাষক (রসায়ন)",
    department: "স্কুল অব সায়েন্স এন্ড ইঞ্জিনিয়ারিং",
    role: "সদস্য",
  },
  {
    id: 6,
    name: "বিপাশা বড়ুয়া",
    designation: "প্রভাষক",
    department: "ইংরেজি ভাষা ও সাহিত্য বিভাগ",
    role: "সদস্য",
  },
  {
    id: 7,
    name: "জনাব মোঃ আবু জাবেদ",
    designation: "সহযোগী অধ্যাপক ও বিভাগীয় প্রধান",
    department: "কম্পিউটার সায়েন্স এন্ড ইঞ্জিনিয়ারিং বিভাগ ও প্রভোস্ট",
    role: "সদস্য",
  },
  {
    id: 8,
    name: "জনাব এস এম শহীদুল আলম",
    designation: "সহকারী রেজিস্ট্রার ও পরিচালক",
    department: "স্টুডেন্ট অ্যাফেয়ার্স",
    role: "সদস্য সচিব",
    type: "secretary",
  },
];

const responsibilities = [
  {
    icon: ShieldCheck,
    title: "নিরাপদ ক্যাম্পাস",
    description:
      "যৌন নিপীড়নমুক্ত ও নিরাপদ ক্যাম্পাস নিশ্চিত করার জন্য কার্যকর ব্যবস্থা গ্রহণ করা।",
  },
  {
    icon: Megaphone,
    title: "সচেতনতা সৃষ্টি",
    description:
      "ছাত্র-ছাত্রীদের মধ্যে যৌন নিপীড়ন ও তৎসম্পর্কে সচেতনতা সৃষ্টি করা।",
  },
  {
    icon: SearchCheck,
    title: "দ্রুত তদন্ত",
    description:
      "যৌন নিপীড়নের কোনো ঘটনা সংঘটিত হলে দ্রুত তদন্তের মাধ্যমে প্রয়োজনীয় সহায়তা প্রদান করা।",
  },
  {
    icon: Scale,
    title: "প্রতিরোধমূলক ব্যবস্থা",
    description:
      "ঘটনার বিরুদ্ধে যথাযথ প্রতিরোধমূলক ব্যবস্থা গ্রহণ এবং একটি নিরাপদ শিক্ষার পরিবেশ বজায় রাখা।",
  },
];

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

function AntiSexual() {
  const [showNotice, setShowNotice] = useState(false);
  const [activeMember, setActiveMember] = useState(null);

  return (
    <div className="min-h-screen bg-[#f7fafc] text-slate-800">
      {/* Background decoration */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -left-40 -top-40 h-[500px] w-[500px] rounded-full bg-[#016C94]/10 blur-3xl" />
        <div className="absolute -right-40 top-[35%] h-[500px] w-[500px] rounded-full bg-[#d6a900]/10 blur-3xl" />
      </div>

      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#003f59] via-[#016C94] to-[#008e91]" />

        <div className="absolute inset-0 opacity-20">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.15) 1px, transparent 1px)",
              backgroundSize: "45px 45px",
            }}
          />
        </div>

        <motion.div
          animate={{
            y: [0, -15, 0],
            rotate: [0, 2, 0],
          }}
          transition={{
            duration: 7,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute right-[8%] top-16 hidden h-40 w-40 rounded-full border border-white/10 bg-white/5 lg:block"
        />

        <motion.div
          animate={{
            y: [0, 18, 0],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute bottom-[-80px] left-[5%] hidden h-60 w-60 rounded-full border border-white/10 bg-white/5 lg:block"
        />

        <div className="relative mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            className="max-w-4xl"
          >
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-medium text-white backdrop-blur-md">
              <ShieldCheck size={18} />
              UCTC • Student Affairs
            </div>

            <h1 className="text-4xl font-extrabold leading-tight text-white sm:text-5xl lg:text-6xl">
              যৌন নিপীড়ন প্রতিরোধ
              <span className="mt-2 block text-[#f3d36a]">
                অভিযোগ কমিটি
              </span>
            </h1>

            <p className="mt-6 max-w-3xl text-base leading-8 text-white/80 sm:text-lg">
              একটি নিরাপদ, সম্মানজনক ও সহায়ক শিক্ষার পরিবেশ নিশ্চিত করার
              লক্ষ্যে ইউনিভার্সিটি অব ক্রিয়েটিভ টেকনোলজি চিটাগাং-এর
              যৌন নিপীড়ন প্রতিরোধ অভিযোগ কমিটি গঠন করা হয়েছে।
            </p>

            <div className="mt-9 flex flex-wrap gap-4">
              <a
                href="#committee"
                className="flex items-center gap-2 rounded-xl bg-white px-6 py-3.5 font-bold text-[#016C94] shadow-xl transition hover:-translate-y-1 hover:shadow-2xl"
              >
                <Users size={19} />
                কমিটির সদস্যবৃন্দ
              </a>

              <button
                onClick={() => setShowNotice(true)}
                className="flex items-center gap-2 rounded-xl border border-white/30 bg-white/10 px-6 py-3.5 font-bold text-white backdrop-blur-md transition hover:-translate-y-1 hover:bg-white/20"
              >
                <Eye size={19} />
                অফিসিয়াল নোটিশ
              </button>
            </div>
          </motion.div>

          {/* Hero cards */}
          <motion.div
            initial="hidden"
            animate="visible"
            variants={stagger}
            className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-3"
          >
            <HeroStat
              icon={<Users />}
              number="০৮"
              label="কমিটি সদস্য"
            />
            <HeroStat
              icon={<Clock3 />}
              number="০২"
              label="বছরের মেয়াদ"
            />
            <HeroStat
              icon={<ShieldCheck />}
              number="২৪/৭"
              label="নিরাপত্তার অঙ্গীকার"
            />
          </motion.div>
        </div>
      </section>

      {/* INTRO */}
      <section className="relative mx-auto max-w-7xl px-5 py-20 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
          className="mx-auto max-w-3xl text-center"
        >
          <span className="font-semibold tracking-widest text-[#d19d00]">
            OUR COMMITMENT
          </span>

          <h2 className="mt-3 text-3xl font-extrabold text-slate-900 sm:text-4xl">
            নিরাপদ ক্যাম্পাস, সম্মানজনক পরিবেশ
          </h2>

          <p className="mt-5 leading-8 text-slate-600">
            UCTC-এর এই কমিটি যৌন নিপীড়ন প্রতিরোধ, সচেতনতা বৃদ্ধি, অভিযোগের
            দ্রুত তদন্ত এবং প্রয়োজনীয় প্রতিরোধমূলক ব্যবস্থা গ্রহণে কাজ করবে।
          </p>
        </motion.div>
      </section>

      {/* RESPONSIBILITIES */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <div className="mb-12">
              <span className="font-semibold tracking-widest text-[#d19d00]">
                COMMITTEE RESPONSIBILITIES
              </span>

              <h2 className="mt-2 text-3xl font-extrabold text-slate-900 sm:text-4xl">
                কমিটির কার্যপরিধি
              </h2>
            </div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={stagger}
            className="grid gap-6 md:grid-cols-2"
          >
            {responsibilities.map((item, index) => (
              <ResponsibilityCard
                key={item.title}
                item={item}
                index={index}
              />
            ))}
          </motion.div>
        </div>
      </section>

      {/* COMMITTEE */}
      <section
        id="committee"
        className="relative overflow-hidden bg-[#f3f8fa] py-20"
      >
        <div className="absolute right-0 top-0 h-96 w-96 rounded-full bg-[#016C94]/5 blur-3xl" />

        <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            className="mb-12"
          >
            <span className="font-semibold tracking-widest text-[#d19d00]">
              COMMITTEE MEMBERS
            </span>

            <h2 className="mt-2 text-3xl font-extrabold text-slate-900 sm:text-4xl">
              কমিটির সদস্যবৃন্দ
            </h2>

            <p className="mt-4 max-w-2xl leading-7 text-slate-600">
              বিশ্ববিদ্যালয়ের বিভিন্ন বিভাগ ও প্রশাসনিক পর্যায়ের
              প্রতিনিধিদের সমন্বয়ে কমিটিটি গঠিত।
            </p>
          </motion.div>

          {/* President */}
          {members
            .filter((member) => member.type === "president")
            .map((member) => (
              <motion.div
                key={member.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="mb-7"
              >
                <MemberCard
                  member={member}
                  featured
                  onClick={() => setActiveMember(member)}
                />
              </motion.div>
            ))}

          {/* Members */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={stagger}
            className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
          >
            {members
              .filter(
                (member) =>
                  member.type !== "president" &&
                  member.type !== "secretary"
              )
              .map((member) => (
                <motion.div key={member.id} variants={fadeUp}>
                  <MemberCard
                    member={member}
                    onClick={() => setActiveMember(member)}
                  />
                </motion.div>
              ))}
          </motion.div>

          {/* Secretary */}
          {members
            .filter((member) => member.type === "secretary")
            .map((member) => (
              <motion.div
                key={member.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="mt-7"
              >
                <MemberCard
                  member={member}
                  featured
                  secretary
                  onClick={() => setActiveMember(member)}
                />
              </motion.div>
            ))}
        </div>
      </section>

      {/* TENURE */}
      <section className="relative overflow-hidden bg-[#003f59] py-20">
        <div className="absolute inset-0 opacity-10">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "radial-gradient(circle at 20% 20%, white 1px, transparent 1px)",
              backgroundSize: "28px 28px",
            }}
          />
        </div>

        <div className="relative mx-auto max-w-5xl px-5 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <Clock3 className="mx-auto mb-5 text-[#f3d36a]" size={42} />

            <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
              কমিটির মেয়াদ
            </h2>

            <p className="mx-auto mt-5 max-w-2xl leading-8 text-white/70">
              এই কমিটি গঠনের তারিখ থেকে আগামী{" "}
              <strong className="text-[#f3d36a]">২ বছর</strong> পর্যন্ত
              বহাল থাকবে।
            </p>

            <div className="mx-auto mt-8 flex max-w-md items-center justify-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-6 py-5 backdrop-blur-md">
              <div className="rounded-xl bg-[#f3d36a]/15 p-3">
                <CalendarIcon />
              </div>

              <div className="text-left">
                <p className="text-xs font-medium uppercase tracking-widest text-white/50">
                  Committee Tenure
                </p>
                <p className="font-bold text-white">
                  ২ বছর পর্যন্ত কার্যকর
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* NOTICE */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="font-semibold tracking-widest text-[#d19d00]">
                OFFICIAL DOCUMENT
              </span>

              <h2 className="mt-3 text-3xl font-extrabold text-slate-900 sm:text-4xl">
                অফিসিয়াল নোটিশ
              </h2>

              <p className="mt-5 leading-8 text-slate-600">
                যৌন নিপীড়ন প্রতিরোধ অভিযোগ কমিটি সংক্রান্ত বিশ্ববিদ্যালয়ের
                অফিসিয়াল নোটিশটি এখানে দেখা যাবে।
              </p>

              <button
                onClick={() => setShowNotice(true)}
                className="mt-7 inline-flex items-center gap-2 rounded-xl bg-[#016C94] px-6 py-3.5 font-bold text-white shadow-lg shadow-[#016C94]/20 transition hover:-translate-y-1 hover:bg-[#005775]"
              >
                <Eye size={19} />
                নোটিশ দেখুন
                <ExternalLink size={16} />
              </button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-3 shadow-xl"
            >
              <img
                src="/assets/51Anti-Sexual-Harrassment-Committee.jpeg"
                alt="UCTC Anti Sexual Harassment Committee Notice"
                className="max-h-[650px] w-full rounded-2xl object-contain"
              />

              <button
                onClick={() => setShowNotice(true)}
                className="absolute inset-0 m-auto flex h-14 w-14 scale-90 items-center justify-center rounded-full bg-[#016C94] text-white opacity-0 shadow-xl transition-all duration-300 group-hover:scale-100 group-hover:opacity-100"
              >
                <Eye size={23} />
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      
      {/* MEMBER MODAL */}
      <AnimatePresence>
        {activeMember && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 p-5 backdrop-blur-sm"
            onClick={() => setActiveMember(null)}
          >
            <motion.div
              initial={{ opacity: 0, y: 30, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 30, scale: 0.95 }}
              onClick={(e) => e.stopPropagation()}
              className="relative w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl"
            >
              <div className="h-28 bg-gradient-to-r from-[#003f59] to-[#016C94]" />

              <button
                onClick={() => setActiveMember(null)}
                className="absolute right-5 top-5 rounded-full bg-white/15 p-2 text-white backdrop-blur-md hover:bg-white/25"
              >
                <X size={20} />
              </button>

              <div className="-mt-10 px-7 pb-7">
                <div className="flex h-20 w-20 items-center justify-center rounded-2xl border-4 border-white bg-[#016C94] text-white shadow-xl">
                  <UserCheck size={34} />
                </div>

                <div className="mt-5">
                  <span className="rounded-full bg-[#016C94]/10 px-3 py-1 text-xs font-bold text-[#016C94]">
                    {activeMember.role}
                  </span>

                  <h3 className="mt-3 text-2xl font-extrabold text-slate-900">
                    {activeMember.name}
                  </h3>

                  <p className="mt-2 font-semibold text-[#016C94]">
                    {activeMember.designation}
                  </p>

                  <p className="mt-1 leading-7 text-slate-500">
                    {activeMember.department}
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* NOTICE MODAL */}
      <AnimatePresence>
        {showNotice && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-3 backdrop-blur-sm sm:p-6"
            onClick={() => setShowNotice(false)}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.94, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.94, y: 20 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
              className="relative flex max-h-[95vh] max-w-5xl justify-center overflow-auto rounded-2xl bg-white p-2 shadow-2xl"
            >
              <button
                onClick={() => setShowNotice(false)}
                className="fixed right-5 top-5 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-black/70 text-white backdrop-blur-md transition hover:bg-black"
              >
                <X size={22} />
              </button>

              <img
                src={noticeImage}
                alt="Official UCTC Anti Sexual Harassment Committee Notice"
                className="h-auto max-h-[92vh] w-auto max-w-full rounded-xl object-contain"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function HeroStat({ icon, number, label }) {
  return (
    <motion.div
      variants={fadeUp}
      className="rounded-2xl border border-white/10 bg-white/10 p-5 backdrop-blur-md"
    >
      <div className="flex items-center gap-4">
        <div className="rounded-xl bg-white/10 p-3 text-[#f3d36a]">
          {icon}
        </div>

        <div>
          <p className="text-2xl font-extrabold text-white">{number}</p>
          <p className="text-sm text-white/60">{label}</p>
        </div>
      </div>
    </motion.div>
  );
}

function ResponsibilityCard({ item, index }) {
  const Icon = item.icon;

  return (
    <motion.div
      variants={fadeUp}
      className="group rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#016C94]/20 hover:shadow-xl"
    >
      <div className="flex gap-5">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#016C94]/10 text-[#016C94] transition-colors group-hover:bg-[#016C94] group-hover:text-white">
          <Icon size={26} />
        </div>

        <div>
          <div className="mb-1 text-xs font-bold text-[#d19d00]">
            ০{index + 1}
          </div>

          <h3 className="text-xl font-bold text-slate-900">
            {item.title}
          </h3>

          <p className="mt-2 leading-7 text-slate-500">
            {item.description}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

function MemberCard({ member, featured = false, secretary = false, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`group relative w-full overflow-hidden rounded-2xl border bg-white text-left shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
        featured
          ? "border-[#016C94]/20 p-6"
          : "border-slate-200 p-5"
      }`}
    >
      <div
        className={`absolute left-0 top-0 h-full w-1 ${
          secretary ? "bg-[#d19d00]" : "bg-[#016C94]"
        }`}
      />

      <div className="flex items-start gap-4">
        <div
          className={`flex shrink-0 items-center justify-center rounded-2xl ${
            featured ? "h-16 w-16" : "h-14 w-14"
          } ${
            secretary
              ? "bg-[#d19d00]/10 text-[#aa8200]"
              : "bg-[#016C94]/10 text-[#016C94]"
          }`}
        >
          {secretary ? (
            <Building2 size={28} />
          ) : (
            <GraduationCap size={28} />
          )}
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h3
              className={`font-extrabold text-slate-900 ${
                featured ? "text-xl" : "text-lg"
              }`}
            >
              {member.name}
            </h3>

            <span
              className={`rounded-full px-2.5 py-1 text-[10px] font-bold ${
                member.role === "সভাপতি"
                  ? "bg-[#016C94] text-white"
                  : member.role === "সদস্য সচিব"
                  ? "bg-[#d19d00] text-white"
                  : "bg-slate-100 text-slate-600"
              }`}
            >
              {member.role}
            </span>
          </div>

          <p className="mt-2 text-sm font-semibold text-[#016C94]">
            {member.designation}
          </p>

          <p className="mt-1 text-sm leading-6 text-slate-500">
            {member.department}
          </p>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-end gap-1 text-xs font-semibold text-[#016C94] opacity-0 transition-opacity group-hover:opacity-100">
        বিস্তারিত দেখুন
        <ChevronDown className="-rotate-90" size={14} />
      </div>
    </button>
  );
}

function CalendarIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
      <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
    </svg>
  );
}

export default AntiSexual;